import React, { createContext, FC, useContext } from 'react';
import { type NodeInstanceDataPort } from '@glueapp/graph-types';

export const NodeShapeContext = createContext<(shape: { inPorts: NodeInstanceDataPort[]; outPorts: NodeInstanceDataPort[] }) => void>(
    () => {},
);

interface NodeShapeContextProviderProps {
    setNodeShape: (shape: { inPorts: NodeInstanceDataPort[]; outPorts: NodeInstanceDataPort[] }) => void;
    children: React.ReactNode;
}

export const NodeShapeContextProvider: FC<NodeShapeContextProviderProps> = props => {
    return <NodeShapeContext.Provider value={props.setNodeShape}>{props.children}</NodeShapeContext.Provider>;
};

export function useNodeShape() {
    return useContext(NodeShapeContext);
}
